/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = None

1 = Exclusive

2 = Inclusive


 */
export type TaxMethod = (typeof TaxMethod)[keyof typeof TaxMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaxMethod = {
  None: 0,
  Exclusive: 1,
  Inclusive: 2,
} as const;
